import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import CookieConsent from "./CookieConsent";
const Footer = () => {
  const [cookieConsentOpen, setCookieConsentOpen] = useState(false);
  
  return <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">AI LAB SWEDEN AB</h3>
            <p className="text-muted-foreground mb-4">
              AI-labbet is the leading provider of services for creating and realizing results with AI investments in a responsible way. We help our clients to achieve value from AI by aligning their business initiatives, goals and processes with technology ambitions and opportunities.
            </p>
            <p className="text-muted-foreground mb-4">
              Org. no. 559415-2919
            </p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/ai-labbet/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
                  About us
                </Link>
              </li>
              <li>
                <Link to="/#services" className="text-muted-foreground hover:text-foreground transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/ai-skilling" className="text-muted-foreground hover:text-foreground transition-colors">
                  AI-skilling
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-muted-foreground hover:text-foreground transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <div className="space-y-2 text-muted-foreground">
              <p>Malmskillnadsgatan 36, 111 57 Stockholm</p>
              <p>
                <a href="mailto:info@ailabbet.com" className="hover:text-foreground transition-colors">
                  info@ailabbet.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <p>&copy; {new Date().getFullYear()} AI Lab Sweden AB. All rights reserved.</p>
            <div className="flex items-center gap-3">
              <Link to="/privacy-policy" className="hover:text-foreground transition-colors">
                Privacy
              </Link>
              <span>·</span>
              <button 
                onClick={() => setCookieConsentOpen(true)}
                className="hover:text-foreground transition-colors"
              >
                Cookies
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <CookieConsent isOpen={cookieConsentOpen} onOpenChange={setCookieConsentOpen} />
    </footer>;
};
export default Footer;